export const Active = {
    name: 'Active',
    value: 'ACTIVE',
    sequence: 1,
};
export const Inactive = {
    name: 'Inactive',
    value: 'INACTIVE',
    sequence: 2,
};
export const Deleted = {
    name: 'Deleted',
    value: 'DELETED',
    sequence: 3,
};
export const StatusPriorities = {
    [Active.value]: 10,
    [Inactive.value]: 5,
    [Deleted.value]: 1,
};
const Basic = [Active, Inactive, Deleted];
const BasicWithoutDelete = [Active, Inactive];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
export const isActive = node => node.status === Active.value;
export const isInactive = node => node.status === Inactive.value;
export const isDeleted = node => node.status === Deleted.value;
const BasicProps = Object.keys(BasicByValue);
export default {
    Basic,
    BasicWithoutDelete,
    BasicByValue,
    BasicProps,
    Active,
    Inactive,
    Deleted,
    StatusPriorities,
    isActive,
    isInactive,
    isDeleted,
};
